/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { Card } from 'flowbite-react';

import Form, { ValidationMode } from 'components/Common/Form';
import FormControl from 'components/Common/FormControl';
import Input, { Type as InputType } from 'components/Common/Input';
import Button from 'components/Common/Button';
import ErrorMessage from 'components/Typography/ErrorMessage';
import { completeNewPassword } from 'state/actions/auth';
import { selectChangePasswordState } from 'state/selectors/auth';
import showPasswordIcon from 'assets/icons/eye-outline.svg';
import hidePasswordIcon from 'assets/icons/eye-slash-outline.svg';
import kardLogo from 'assets/logos/kard-blue.svg';

import PasswordRequirements from 'components/Common/PasswordRequirements';
import validationSchema from './PasswordChangeRequiredForm.schema';

const PasswordChangeRequiredForm = () => {
  const dispatch = useDispatch();

  const { loading, error } = useSelector(
    selectChangePasswordState,
    shallowEqual,
  );

  const [showPassword, setShowPassword] = useState(false);
  const [valid, setValid] = useState(false);

  const onSubmitHandler = useCallback(
    ({ password }) => {
      dispatch(completeNewPassword(password));
    },
    [dispatch],
  );

  const onChangeShowPassword = useCallback(
    () => setShowPassword((prevState) => !prevState),
    [],
  );
  return (
    <div className="mb-72 flex w-[499px] flex-col gap-6 p-6">
      <div className="flex items-center justify-center gap-10 pb-6">
        <img className="h-9 w-24" src={kardLogo} alt="kard logo" />
      </div>
      <Card className="rounded-lg shadow-custom">
        <div className="flex flex-col items-start">
          <h1 className="text-gray900 text-2xl font-bold leading-tight">
            Create a new password
          </h1>
        </div>
        <Form
          validationSchema={validationSchema}
          validationMode={ValidationMode.OnBlur}
          onSubmit={onSubmitHandler}
          setValid={setValid}
        >
          <label className="text-gray900 text-sm font-medium">
            New password
          </label>
          <div className="relative">
            <FormControl
              name="password"
              render={(props) => (
                <Input
                  placeholder=""
                  className="mt-2"
                  type={showPassword ? InputType.Text : InputType.Password}
                  isFullScreen
                  {...props}
                />
              )}
            />
            <img
              src={showPassword ? hidePasswordIcon : showPasswordIcon}
              alt="hide or show password"
              className="absolute right-[13px] top-[21px] h-4 w-4 cursor-pointer opacity-75"
              onClick={onChangeShowPassword}
            />
          </div>
          <PasswordRequirements />
          {error && <ErrorMessage>{error}</ErrorMessage>}
          <Button
            type="submit"
            loading={loading}
            disabled={!valid}
            className="!m-0"
          >
            Save password
          </Button>
        </Form>
      </Card>
    </div>
  );
};

export default PasswordChangeRequiredForm;
